export class ProjectAnalyticsMembersDetailModel {
    constructor() {
        this.teamMembers = [];
        this.projectDailyHoursCalculations = [];
    }
}
export default class ProjectAnalyticsMembersDetail extends ProjectAnalyticsMembersDetailModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
